import format from 'date-fns/format';
import { Platform } from 'react-native';
import { OnboardingStateManager } from '../../flows/user/functions/onboardingState';
import { AnalyticEvents } from '../../generated/AnalyticEvents';
import AsyncStorage, { DailyLaunchCount, Key } from '../../utils/asyncStorage';

export default {
  trackApplicationLaunch: async () => {
    const previousDailyLaunchCount =
      await AsyncStorage.getJSONData<DailyLaunchCount>(Key.DailyLaunchCount);

    const localDate = format(new Date(), 'yyyy-MM-dd');
    const todayLaunchCount = previousDailyLaunchCount?.[localDate] ?? 0;

    const updatedDailyLaunchCount: DailyLaunchCount = {
      ...previousDailyLaunchCount,
      [localDate]: todayLaunchCount + 1,
    };

    await AsyncStorage.storeJSONData(
      Key.DailyLaunchCount,
      updatedDailyLaunchCount,
    );

    const previousCount = await AsyncStorage.getNumberData(Key.LaunchCount);
    const count = (previousCount ?? 0) + 1;

    if (Platform.OS !== 'web') {
      AnalyticEvents.default.appLaunched({ counter: count });
    }

    await AsyncStorage.storeNumberData(Key.LaunchCount, count);
    OnboardingStateManager.shared.appLaunchedWithCounter(count);
  },
};
